import type { Hookable } from 'hookable'

import type { TeamContextEvents } from '../useTeamContext.events.schema'

type TeamContextHookMap = {
  [K in keyof TeamContextEvents]: (event: TeamContextEvents[K]) => void | Promise<void>
}

/**
 * Handle for removing a previously registered team context hook.
 */
type TeamContextUnsubscribe = () => void

interface TeamContextLoggerLike {
  debug: (message: string, meta?: Record<string, unknown> | unknown) => void
}

interface UseTeamContextOnPlanIdChangedParams {
  hooks: Hookable<TeamContextHookMap>
  logger: TeamContextLoggerLike
}

/**
 * Internal handler: debug hook for harmony plan route param changes.
 */
export default function useTeamContextOnPlanIdChanged({ hooks, logger }: UseTeamContextOnPlanIdChangedParams) {
  const unsubscribe: TeamContextUnsubscribe = hooks.hook(
    'PlanIdChanged',
    ({ harmonyPlanId, previousHarmonyPlanId }) => {
      logger.debug('PlanId changed', { previousHarmonyPlanId, harmonyPlanId })
    },
  )

  return unsubscribe
}
